import React from 'react';
import PageAnimator from './PageAnimator';

const PageContainer = ({ children, className = "" }) => {
    return (
        <PageAnimator className={`max-w-7xl mx-auto p-3 md:p-6 space-y-6 ${className}`}>
            {children}
        </PageAnimator>
    );
};

export default PageContainer;
